<template>
  <div :class="['c-list', `-${distance}`]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CList',
  props: {
    distance: {
      type: String,
      default: 'normal',
    },
  },
};
</script>

<style lang="scss" type="text/scss">
  .c-list {
    > * {
      &:not(:last-child) {
        margin-bottom: 1.4rem;
      }
    }

    &.-small {
      > * {
        &:not(:last-child) {
          margin-bottom: .8rem;
        }
      }
    }

    /* stylelint-disable no-descending-specificity */
    &.-large {
      > * {
        &:not(:last-child) {
          margin-bottom: 2rem;
        }
      }
    }
    /* stylelint-enable no-descending-specificity */
  }
</style>
